
import { defineComponent, reactive, SetupContext } from "vue";

interface MessageProps {
  name: string;
  message: string;
}

export default defineComponent({
  name: "PostBoard",
  setup(props, context: SetupContext) {
    const post = reactive<MessageProps>({
      name: "",
      message: "",
    });
    function postAction() {
      context.emit("post-board", post);
    }
    return { post, postAction };
  },
});
